<div class="container-fluid">

  <div class="row">
    <div class="col-lg-12">
      <h2>@if (beds) {
        <span>{{beds.length}}</span>
      } Bed(s)</h2>
    </div>
    <div class="col-lg-12">
      <button mat-button style="padding: 0; color:green" (click)="openFormAdd()">
        <mat-icon style="font-size:140%">add_circle</mat-icon> Add Bed
      </button>
    </div>
  </div>

  <div class="row">
    @for (bed of beds; track bed; let i = $index) {
      <div class="col-lg-12">
        <app-bed-form class="flex-1" [bed]="bed" (doAdd)="addBed($event)" (doUpdate)="updateBed($event)" (doDelete)="deleteBed($event)"></app-bed-form>
        <br><br>
        <mat-divider></mat-divider>
        <br><br>
      </div>
    }
  </div>
</div>
